import { CircleJobs, FaqBurger, Suitcase } from 'app/assets/icons'
import { breakpoints, media } from 'app/assets/styles'
import { Cards } from 'app/common/cards'
import { ErrorManagement } from 'app/common/error-management'
import { Layout } from 'app/common/layout'
import { Push } from 'app/common/push'
import React, { Component } from 'react'
import type { IntlShape } from 'react-intl'
import { injectIntl } from 'react-intl'
import Responsive from 'react-responsive'
import { colors } from 'shared/assets/styles'
import styled, { css } from 'styled-components'
import { Infos } from './infos'
import type { Coordinates, Restaurant } from 'shared/types'
import { CURRENT_MAP_VIEW, MapWoosmap } from 'app-v2/modules/geolocation'

const { red } = colors
type Props = {
    restaurant: ?Restaurant,
    userPosition?: Coordinates,
    match: any,
    fetchPageData: string => void,
    error?: any,
    networkError?: any,
    intl: IntlShape
}

const { medium } = breakpoints

class _RestaurantComponent extends Component<Props> {
    componentDidMount() {
        const { fetchPageData, match } = this.props
        fetchPageData(match.params.restaurantPath)
    }

    render() {
        const {
            restaurant,
            userPosition,
            error,
            networkError,
            match,
            intl
        } = this.props

        if (error) {
            return <ErrorManagement error={error} networkError={networkError} />
        }
        if (restaurant) {
            const { coordinates, id, image, news } = restaurant
            const backgroundImage = <BackgroundImage image={image[0]} />
            const infos = (
                <Infos
                    restaurantId={id}
                    userPosition={userPosition}
                    pageUrl={match.params.restaurantPath}
                    {...restaurant}
                />
            )
            const map = (
                <MapWoosmap
                    ContainerMap={MapContainer}
                    onSelectRestaurant={() => {}}
                    restaurant={restaurant}
                    currentView={CURRENT_MAP_VIEW.RESTAURANT}
                />
            )
            return (
                <Layout background="plain" border>
                    <Main>
                        {/* Mobile Layout */}
                        <Responsive maxWidth={medium - 1}>
                            {backgroundImage}
                            {infos}
                            {map}
                        </Responsive>
                        {/* Desktop Layout */}
                        <Responsive minWidth={medium}>
                            <Block>{infos}</Block>
                            <Block>
                                {backgroundImage}
                                <Content>{map}</Content>
                            </Block>
                        </Responsive>
                    </Main>
                    {/* News */}
                    {news && news.length > 0 && (
                        <Cards
                            secondary={news}
                            title="restaurant.news.title"
                            noRatio
                        />
                    )}
                    {/* Job */}
                    <JobContainer>
                        <IconContainer>
                            <FaqBurger />
                        </IconContainer>
                        <Push
                            external
                            background={red}
                            btnBackground="none"
                            ratio={1}
                            textColor="white"
                            btnTextColor="white"
                            btnBorder="white"
                            className="jobs"
                            title={intl.formatMessage({
                                id: 'restaurant.jobs.title'
                            })}
                            button={intl.formatMessage({
                                id: 'restaurant.jobs.button'
                            })}
                            actionUrl={intl.formatMessage({
                                id: 'restaurant.jobs.url'
                            })}>
                            <CircleJobs />
                        </Push>
                        <SuitcaseIconContainer>
                            <Suitcase />
                        </SuitcaseIconContainer>
                    </JobContainer>
                </Layout>
            )
        }
        return null
    }
}

const Main = styled.section`
    width: 100%;
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    ${media.medium`
        margin-top: 90px;
        flex-direction: row;
    `};
`

const Block = styled.div`
    width: 50%;
    ${media.medium`
        display: flex;
        flex-direction: column;
    `};
`

const Content = styled.div`
    ${media.medium`
        height: 50%;
        width: 100%;
    `};
`

const BackgroundImage = styled(Content)`
    background-image: url(${props => props.image});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 400px;
    ${media.medium`
        height: 50%;
    `};
`

const MapContainer = styled.div`
    width: 100%;
    height: 400px;
    ${media.medium`
        height: 100%;
    `};
`

const JobContainer = styled.div`
    position: relative;
`

const icon = css`
    display: none;
    ${media.medium`
        display: block;
        position: absolute;
        z-index: 2;
        transform: translateY(-50%);
        top: 50%;
    `};
`

const IconContainer = styled.div`
    ${icon};
    left: -30px;
`

const SuitcaseIconContainer = styled.div`
    ${icon};
    right: -30px;
`

const RestaurantComponent = injectIntl(_RestaurantComponent)

export { RestaurantComponent }
